import React from "react";
import { useTranslation } from "react-i18next";

// Visual weight climbs with the tier so rank is readable at a glance in a list.
const STYLE = {
  bronze: "bg-amber-50 text-amber-700 ring-amber-200",
  silver: "bg-slate-100 text-slate-600 ring-slate-300",
  gold: "bg-yellow-50 text-yellow-700 ring-yellow-300",
  platinum: "bg-indigo-50 text-indigo-700 ring-indigo-300",
};

export default function TierBadge({ tier = "bronze", size = "sm" }) {
  const { t } = useTranslation();
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      data-testid={`tier-${tier}`}
      className={`inline-flex items-center rounded-full font-semibold ring-1 ${pad} ${STYLE[tier] || STYLE.bronze}`}
    >
      {t(`tiers.${tier}`)}
    </span>
  );
}
